<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Заполните данные о&nbsp;договоре&nbsp;страхования</h3>
      <div class="step__contract" :class="{'step__contract_first': i === 1}" v-for="i in contractCount" :key="form.contracts[i-1].key">
        <div class="step__contract-close" v-if="i !== 1" @click="$store.commit('deleteContract', form.contracts[i-1].key)">
          <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.96875 9.46387L24.0016 24.4967" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.96875 24.5361L24.0016 9.50328" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <TextInput :required="true" class="aoformlabel_halfspace" @setError="errors[`contract-${i}-id`] = $event" v-model="form.contracts[i-1].id" text="Номер договора страхования" :validation="contractIdValidation" :name="`contract-${i}-id`"/>
        <DateInput :required="true" @setError="errors[`contract-${i}-date`] = $event" :name="`contract-${i}-date`" text="Дата заключения договора страхования" :range="false" v-model="form.contracts[i-1].date" />
      </div>
      <AddBtn class="addbtn_mobincmargin" @click="()=>this.$store.commit('addContract', key++)">Добавить еще договор</AddBtn>
      <div class="step__line"></div>
      <Btn class="step__next" :disabled="!filled" @click="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import AddBtn from '../AddBtn.vue';
import Btn from '../Btn.vue';
import DateInput from '../inputs/DateInput.vue';
export default {
  components: { TextInput, AddBtn, DateInput, Btn },
  props: {
    active: { type: Boolean }
  },
  data: ()=>({
    errors: { },
    key: 1
  }),
  computed: {
    ...mapState(['form']),
    ...mapGetters(['contractCount']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      for (let contract of this.form.contracts)
        if (!contract.id || !contract.date) return false
      return true
    }
  },
  methods: {
    contractIdValidation(val){
      if (val.length > 50) return 'Не более 50 символов'
    },
  }
}
</script>

<style lang="sass">
.step 
  width: 100%
  &:not(&_active)
    max-height: calc(100vh - var(--headeroffset))  
    overflow: hidden
  &__inner
    width: 604px
    max-width: 100%
    margin: 0 auto
  &__contract
    position: relative
    &:not(&_first)::before 
      content: ''
      position: absolute
      transition: background-color .3s ease-out
      left: -15px
      right: -15px
      bottom: -15px
      top: -15px
      border-radius: 10px
    &-close
      position: absolute
      top: -8px
      right: -8px
      z-index: 5
      width: 20px
      height: 20px
      cursor: pointer
      opacity: 0
      color: black
      transition: opacity .3s ease-out
      svg
        width: 100%
        display: block
    &:hover::before
      background-color: rgba(0,0,0,.05)
    &:hover &-close
      opacity: 1

  &__title
    font-weight: 400
    font-size: 24px
    line-height: 1.16
    text-align: center
    margin-bottom: 38px
    color: colors.$gray3
    &_left
      text-align: left
    &_smspace
      margin-bottom: 8px
    &_incspace
      margin-bottom: 64px
  &__minititle
    font-size: 20px
    line-height: 1.18
    font-weight: 400
    color: colors.$gray3
    margin-bottom: 16px
  &__subtitle
    font-size: 14px
    line-height: 1.12
    color: colors.$newgray
    margin-bottom: 40px
    text-align: center
  &__text
    font-size: 16px
    line-height: 1.28
    color: colors.$gray5
    margin-bottom: 8px
  &__line
    border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
    width: 100%
    margin: 40px 0 64px
  &__next
    width: 328px
    max-width: 100%
    margin: 32px auto
  @include for-mob
    &__title
      font-size: 22px
      line-height: 1.16
      margin-bottom: 32px
      &_smspace
        margin-bottom: 8px
    &__subtitle
      margin-bottom: 32px
    &__text
      line-height: 1.12
    &__minititle_spaced
      padding: 32px 0 16px
    &__minititle_spaced-bottom
      padding: 0 0 16px

</style>